module.exports = __webpack_public_path__ + "40114f72dd06606e04ce8b00dec81d30.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/frust_inactive.svg
// module id = 27
// module chunks = 0